import React, { useState } from 'react';
import styles from './CreateNewShipment.module.scss';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup, Table } from 'reactstrap';
import DataTable from 'react-data-table-component';
import AddCategoryProductModal from '../../../../../../components/FBMPortalComponents/AddCategoryProductModal/AddCategoryProductModal';

const packagingData = [
    {
        id: 1,
        image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        packagingType: "Corrugated Box",
        dimension: "6x6x4",
        weight: "1",
    },
    {
        id: 2,
        image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        packagingType: "Bubble Mailer",
        dimension: "8x6",
        weight: "0.5",
    },
    {
        id: 3,
        image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        packagingType: "Corrugated Box",
        dimension: "7x5x3",
        weight: "1.5",
    },
    {
        id: 4,
        image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        packagingType: "Padded Envelope",
        dimension: "10x8",
        weight: "0.75",
    },
];

const packagingColumns = [
    {
        name: "Product",
        cell: (row) => (
            <div className={styles.productInfo}>
                <img
                    src={row.image}
                    alt={row.name}
                    className={styles.productImage}
                />
                <div>
                    <div className={styles.productName}>{row.name}</div>
                    <div className={styles.productSKU}>
                        Product SKU: <span>{row.sku}</span>
                    </div>
                </div>
            </div>
        ),
        minWidth: "350px",
    },
    {
        name: "Packaging Type",
        selector: (row) => row.packagingType,
        minWidth: "180px",
    },
    {
        name: "Dimensions (LxWxH)",
        selector: (row) => row.dimension,
        minWidth: "200px",
    },
    {
        name: "Weight (lbs)",
        selector: (row) => row.weight,
        minWidth: "140px",
    },
];

const customStyles = {
    table: {
        style: {
            border: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            fontSize: '15px',
            div: {
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            div: {
                whiteSpace: "normal !important",
                overflow: "visible !important",
            },
        },
    },
};

const initialData = [
    {
        category: 'Electronics',
        products: [
            {
                name: 'Blue Colored Headphones',
                sku: '#123456789',
                stock: 1000,
                quantityToShip: 200,
                warehouseStock: 50,
                image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            },
            {
                name: 'Blue Colored Headphones',
                sku: '#123456789',
                stock: 1000,
                quantityToShip: 200,
                warehouseStock: 50,
                image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            },
            {
                name: 'Blue Colored Headphones',
                sku: '#123456789',
                stock: 1000,
                quantityToShip: 200,
                warehouseStock: 50,
                image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            },
            {
                name: 'Blue Colored Headphones',
                sku: '#123456789',
                stock: 1000,
                quantityToShip: 200,
                warehouseStock: 50,
                image: require("../../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            },
        ],
    },
];

const CreateNewShipment = () => {
    const [categories, setCategories] = useState(initialData);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleAddProducts = () => {
        setIsModalOpen(true);
        // const newCategory = {
        //     category: `Category ${categories.length + 1}`,
        //     products: [
        //         {
        //             name: "Blue Colored Headphones",
        //             sku: `#123456789`,
        //             stock: 1000,
        //             quantityToShip: 200,
        //             warehouseStock: 50,
        //             image: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        //         },
        //         {
        //             name: "Wireless Headphones",
        //             sku: `#987654321`,
        //             stock: 1500,
        //             quantityToShip: 300,
        //             warehouseStock: 75,
        //             image: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        //         },
        //     ],
        // };

        // setCategories([...categories, newCategory]);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div className={styles.addEditBrandContainer}>
            <h4 className={styles.sectionHeading}>Create new Shipment</h4>

            <Container fluid className={styles.addEditBrandSection}>
                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Shipment Creation Form</h5>
                </div>

                {/* Shipment Creation Form */}
                <Row className={styles.brandFormRow}>
                    <Form className={styles.formSection}>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="shipmentID">Shipment ID:</Label>
                                </Col>
                                <Col lg={5} xxl={4}>
                                    <Input type="text" id="shipmentID" placeholder="Enter Shipment ID" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="shipmentName">Shipment Name:</Label>
                                </Col>
                                <Col lg={5} xxl={4}>
                                    <Input type="text" id="shipmentName" placeholder="Enter Shipment Name" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="warehouse">Warehouse Selection:</Label>
                                </Col>
                                <Col lg={5} xxl={4}>
                                    <Input type="select" id="warehouse">
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="shipmentDate">Shipment Date:</Label>
                                </Col>
                                <Col lg={5} xxl={4}>
                                    <Input type="text" id="shipmentDate" placeholder="Enter Shipment Date" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="carrierInformation">Carrier Information:</Label>
                                </Col>
                                <Col lg={9} xxl={10}>
                                    <Input type="text" id="carrierInformation" placeholder="Enter Carrier Information" className={styles.fullTextInput} />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="trackingNumber">Tracking Number:</Label>
                                </Col>
                                <Col lg={5} xxl={4}>
                                    <Input type="text" id="trackingNumber" placeholder="Enter Tracking Number" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col lg={3} xxl={2} className="pe-lg-2">
                                    <Label for="additionalNotes">Additional Notes:</Label>
                                </Col>
                                <Col lg={9} xxl={10}>
                                    <Input type="textarea" id="additionalNotes" placeholder="Enter Additional Notes" />
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Row>

                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Add Categories & Products to Shipment</h5>
                </div>

                <Row className={styles.categoryProductShipment}>

                    <div className={styles.addProductContainer}>
                        <Button
                            color="info"
                            className={styles.addProductButton}
                            onClick={handleAddProducts}
                        >
                            Add Products
                        </Button>
                    </div>

                    <Row className="g-0">
                        <Col md="12">
                            <Table bordered responsive className={styles.productTable}>
                                <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th>Product</th>
                                        <th>Stock</th>
                                        <th>Quantity to Ship</th>
                                        <th>Stock present at Warehouse</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories?.map((category, categoryIndex) => (
                                        <React.Fragment key={categoryIndex}>
                                            <tr>
                                                {/* Render Category Name with rowspan */}
                                                <td rowSpan={category.products.length}>
                                                    {category.category}
                                                </td>

                                                {/* Render First Product Row */}
                                                <td>
                                                    <div className={styles.productInfo}>
                                                        <img
                                                            src={category.products[0].image}
                                                            alt={category.products[0].name}
                                                            className={styles.productImage}
                                                        />
                                                        <div>
                                                            <div className={styles.productName}>{category.products[0].name}</div>
                                                            <div className={styles.productSKU}>
                                                                Product SKU: <span>{category.products[0].sku}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{category.products[0].stock}</td>
                                                <td>{category.products[0].quantityToShip}</td>
                                                <td>{category.products[0].warehouseStock}</td>
                                            </tr>

                                            {/* Render Remaining Products */}
                                            {category.products.slice(1).map((product, productIndex) => (
                                                <tr key={productIndex}>
                                                    <td>
                                                        <div className={styles.productInfo}>
                                                            <img
                                                                src={product.image}
                                                                alt={product.name}
                                                                className={styles.productImage}
                                                            />
                                                            <div>
                                                                <div className={styles.productName}>{product.name}</div>
                                                                <div className={styles.productSKU}>
                                                                    Product SKU: <span>{product.sku}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{product.stock}</td>
                                                    <td>{product.quantityToShip}</td>
                                                    <td>{product.warehouseStock}</td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Row>

                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Packaging Details</h5>
                </div>

                <Row className={styles.categoryProductShipment}>
                    <DataTable
                        columns={packagingColumns}
                        data={packagingData}
                        customStyles={customStyles}
                    />
                </Row>
            </Container>

            <div className={styles.addProductBtnContainer}>
                <Button type="button" color="primary" className={styles.productBtn}>Create Shipment</Button>
            </div>

            {/* Modal for selecting product categories */}
            <AddCategoryProductModal isModalOpen={isModalOpen} toggleModal={toggleModal} />
        </div>

    )
}

export default CreateNewShipment;